import { render, staticRenderFns } from "./Taxcards.vue?vue&type=template&id=0fcfe8e5"
import script from "./Taxcards.vue?vue&type=script&lang=js"
export * from "./Taxcards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports